// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3nJNX","checkboxCol":"Table_checkboxCol__2cMHE","emailCol":"Table_emailCol__iI9QJ","actionCol":"Table_actionCol__aCkGE"};